import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicLayout from './layouts/Publiclayout';
import Home from './pages/Home';
import Services from './pages/services';
import About from './pages/About';
import Contact from './pages/Contact';

// Auth pages
import { AuthLandingPage } from './features/auth/pages/AuthLandingPage';
import { RoleSelectionPage } from './features/auth/pages/RoleSelectionPage';
import { SignUpPage } from './features/auth/pages/SignUpPage';
import { LoginPage } from './features/auth/pages/LoginPage';
import { VerifyAccount } from './features/auth/pages/OTPPage';
import { ForgotPassword } from './features/auth/pages/ForgotPasswordPage';
import { EmailConfirmation } from './features/auth/pages/EmailConfirmationPage';
import { OTPVerification } from './features/auth/pages/OTPVerificationPage';
import { ResetPassword } from './features/auth/pages/ResetPasswordPage';
import { ResetPasswordSuccess } from './features/auth/pages/ResetPasswordSuccessPage';

// Logged in
import { ProtectedRoute } from './routes/ProtectedRoute';
import PrivateLayout from './layouts/PrivateLayout';
import DashboardHome from './pages/DashboardHome';
import Browse from './pages/Browse';
import Requests from './pages/Request';
// The screen from your image

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public pages */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Auth pages - no layout wrapper */}
        <Route path="/account" element={<AuthLandingPage />} />
        <Route path="/role-selection" element={<RoleSelectionPage />} />
        <Route path="/signup/:type" element={<SignUpPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/otp" element={<VerifyAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/email-confirmation" element={<EmailConfirmation />} />
        <Route path="/otp-verification" element={<OTPVerification />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password-success" element={<ResetPasswordSuccess />} />

        {/* PROTECTED ROUTES (Must be logged in) */}
        <Route element={<ProtectedRoute />}>
            <Route element={<PrivateLayout />}>
                <Route path="/home" element={<DashboardHome />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/requests" element={<Requests />} />
                {/* Future routes like /profile, /settings, /my-bookings will go here */}
            </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;